import React from 'react';
import { CodeSession, STATUS_COLOR, STATUS_LABEL } from './types';
interface Props {
  session: CodeSession;
  breadcrumb: string;
}
export function RequestTab({
  session,
  breadcrumb
}: Props) {
  return <div className="px-5 py-6 space-y-4" data-id="element-536">
      <div className="bg-[#1c1c22] rounded-[16px] border border-white/[0.04] px-4 py-4" data-id="element-537">
        <div className="text-[11px] text-[#8a8680]/70 tracking-wide mb-1" data-id="element-538">{breadcrumb}</div>
        <div className="flex items-center gap-3" data-id="element-539">
          <span className="text-[12px] text-[#8a8680]" data-id="element-540">{session.startedAt}</span>
          <span className="text-[#8a8680]/30" data-id="element-541">·</span>
          <div className="flex items-center gap-1.5" data-id="element-542">
            <div className="w-2 h-2 rounded-full" style={{
            background: STATUS_COLOR[session.status]
          }} data-id="element-543" />
            <span className="text-[12px]" style={{
            color: STATUS_COLOR[session.status]
          }} data-id="element-544">
              {STATUS_LABEL[session.status]}
            </span>
          </div>
        </div>
      </div>
      <div data-id="element-545">
        <div className="text-[11px] text-[#8a8680]/60 uppercase tracking-wide mb-2 px-1" data-id="element-546">Request</div>
        <div className="bg-[#1c1c22] rounded-[16px] border border-white/[0.04] px-4 py-4" data-id="element-547">
          <p className="text-[14px] text-[#e8e4df] leading-relaxed whitespace-pre-wrap" data-id="element-548">
            {session.originalRequest}
          </p>
        </div>
      </div>
    </div>;
}